import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Work from "./pages/Work";
import About from "./pages/About";
import Writing from "./pages/Writing";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import PrivateRoute from "./components/PrivateRoute";

const Login = lazy(() => import("./pages/Login"));
const AdminPanel = lazy(() => import("./components/AdminPanel"));

function App() {
    return (
        <Router>
            <ThemeProvider>
                <AuthProvider>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/work" element={<Work />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/writing" element={<Writing />} />
                            <Route path="/writing/:slug" element={<BlogPost />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/login" element={<Suspense fallback={null}><Login /></Suspense>} />
                            <Route
                                path="/admin"
                                element={
                                    <Suspense fallback={null}>
                                        <PrivateRoute>
                                            <AdminPanel />
                                        </PrivateRoute>
                                    </Suspense>
                                }
                            />
                        </Routes>
                    </Layout>
                </AuthProvider>
            </ThemeProvider>
        </Router>
    );
}

export default App;
